import { h } from 'preact'
import { ArticleType } from '../articles-destination/Types'
import ArticleTopicView from '../articles-destination/ArticleTopicView'
import TopicFeaturedImage from '../topic-list-view/TopicFeaturedImage'
import TopicHeader from '../topic-list-view/TopicHeader'

type Props = {
  topic: ArticleType
}

const ArticlePreview = ({ topic }: Props) => {
  return (
    <div className='box qa-topic-first-post' data-helper='class-toggle'>
      <TopicHeader
        title={topic.title}
        contentType={topic.contentType}
        publicLabel={topic.publicLabel}
        replies={0}
        views={0}
      />
      {
        topic.featuredImage
          ? <TopicFeaturedImage src={topic.featuredImage} alt={topic.title} />
          : <hr className='seperator m-h m-b-0' />
      }
      <ArticleTopicView
        topic={topic}
        isPreview
        currentPage={1}
      />
    </div>
  )
}

export default ArticlePreview
